module.exports = "/static/assets/d2c5248bcb745cf10d1223d05c66fb11.png";